<template>
  <div class="tab-bar" >
    <div class="tab" :class="{active: tabIndex == i}" v-for="(tab, i) in tabArr" :key="i" @click="changeTab(tab, i)">
      <div class="icon" :class="i == 2 ? 'big' : ''">
        <img :src="homeIcon" alt="" v-if="tabIndex !== 0 && i == 0">
        <img :src="homeActiveIcon" alt="" v-if="i == 0 && tabIndex == 0">
        
        <img :src="marketIcon" alt="" v-if="tabIndex !== 1 && i == 1">
        <img :src="marketActiveIcon" alt="" v-if="i == 1 && tabIndex == 1">

        <img :src="tradeIcon" alt="" v-if="i == 2" >

        <img :src="assestIcon" alt="" v-if="tabIndex !== 3 && i == 3">
        <img :src="assestActiveIcon" alt="" v-if="i == 3 && tabIndex == 3">

        <img :src="mineIcon" alt="" v-if="tabIndex !== 4 && i == 4">
        <img :src="mineActiveIcon" alt="" v-if="i == 4 && tabIndex == 4">
      </div>
      <div class="title">{{i18n.t(`common.${tab.title}`)}}</div>
    </div>

    <div class="menu-modal" v-show="showModal">

    </div>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth'
export default {
  name: 'tabbar',
  props:{

  },
  data() {
    return {
      homeIcon: require('../../assets/imgs/tab/index.png'),
      homeActiveIcon: require('../../assets/imgs/tab/index_select.png'),
      marketIcon: require('../../assets/imgs/tab/market.png'),
      marketActiveIcon: require('../../assets/imgs/tab/market_select.png'),
      tradeIcon: require('../../assets/imgs/tab/trade.png'),
      tradeActiveIcon: require('../../assets/imgs/tab/trade.png'),
      assestIcon: require('../../assets/imgs/tab/capital.png'),
      assestActiveIcon: require('../../assets/imgs/tab/capital_select.png'),
      mineIcon: require('../../assets/imgs/tab/user.png'),
      mineActiveIcon: require('../../assets/imgs/tab/user_select.png'),
      tabIndex: 0,
      defaultIcon: '',
      tabRoute: ['index', 'market', 'trade', 'assest', 'mine'],
      tabArr: [
        {title: 'tab1', icon: 'home', path: '/index'},
        {title: 'tab2', icon: 'market', path: '/market'},
        {title: 'tab3', icon: 'trade', path: '/trade'},
        {title: 'tab4', icon: 'assest', path: '/assest'},
        {title: 'tab5', icon: 'mine', path: '/mine'},
      ],
      showModal: false,
      isLogin: false
    }
  },
  watch: {
    $route(val) {
      let name = val.name
      if (this.tabRoute.indexOf(name) > -1) {
        this.init()
      } else {
        this.tabIndex = -1
      }
    }
  },
  mounted() {
    this.init()
    this.isLogin = !!getToken()
  },
  methods: {
    init() {
      let name = this.$route.name
      switch(name) {
        case 'index': this.tabIndex = 0; break;
        case 'market': this.tabIndex = 1; break;
        case 'trade': this.tabIndex = 2; break;
        case 'assest': this.tabIndex = 3; break;
        case 'mine': this.tabIndex = 4; break;
        default: this.tabIndex = -1; break;
      }
    },
    changeTab(tab, i) {
      if (i == 2) {
        if (this.isLogin) {
          if (this.$route.name == 'trade') {
            this.$store.state.showMenuModal = !this.$store.state.showMenuModal
          } else {
            this.$router.replace({
            name: 'trade',
            query: {
              type: 2
            }
          })
          }
        } else {
          this.$router.push({
            name: 'login'
          })
        }
      } else {
        this.tabIndex = i
        this.$router.replace({
          path: tab.path
        })
      }
    }
  }
}
</script>